import { api } from "@/services/api"

import type { CommonService } from "./service"

export type RetrieveServiceResponse = CommonService

export const retrieveService = async (
  serviceId: CommonService["id"]
) => {
  const { body } = await api.get<RetrieveServiceResponse>(
    `/beepaidgo/services/${serviceId}/`
  )
  return body
}
